import { Component, OnInit, Renderer2 } from '@angular/core';
@Component({
 selector: 'app-agenq-widget',
 standalone: true,
 template: `<div id="agent-container"></div>`,
})
export class AgenqWidgetComponent implements OnInit {
 constructor(private renderer: Renderer2) {}
 ngOnInit() {
 const link = this.renderer.createElement('link');
 link.rel = 'stylesheet';
 link.href = 'https://cdn.agenqglobal.com/agenq-widget.css';
 this.renderer.appendChild(document.head, link);
 const script = this.renderer.createElement('script');
 script.src = 'https://cdn.agenqglobal.com/agenq-widget.iife.js';
 script.onload = () => {
 (window as any).renderAGENQWidget('agent-container', {});
 };
 this.renderer.appendChild(document.body, script);
 }
}